import { render } from "./TransitionTranslateLeft.vue?vue&type=template&id=3c56487e"
import script from "./TransitionTranslateLeft.vue?vue&type=script&lang=js"
export * from "./TransitionTranslateLeft.vue?vue&type=script&lang=js"

import "./TransitionTranslateLeft.vue?vue&type=style&index=0&id=3c56487e&lang=css"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__